/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Auto_DetectionInputs */

const en_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto detection`)
};

const ar_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكشف التلقائي`)
};

const bn_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্বয়ংক্রিয় শনাক্তকরণ`)
};

const de_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Erkennung`)
};

const es_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección automática`)
};

const fr_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection automatique`)
};

const pt_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deteção automática`)
};

const zh_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动识别`)
};

const tr_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomatik algılama`)
};

const ru_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоопределение`)
};

const pl_svchip_auto_detection = /** @type {(inputs: Svchip_Auto_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autodetekcja`)
};

/**
* | output |
* | --- |
* | "Auto detection" |
*
* @param {Svchip_Auto_DetectionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_auto_detection = /** @type {((inputs?: Svchip_Auto_DetectionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Auto_DetectionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_auto_detection(inputs)
	if (locale === "bn") return bn_svchip_auto_detection(inputs)
	if (locale === "de") return de_svchip_auto_detection(inputs)
	if (locale === "es") return es_svchip_auto_detection(inputs)
	if (locale === "fr") return fr_svchip_auto_detection(inputs)
	if (locale === "pt") return pt_svchip_auto_detection(inputs)
	if (locale === "zh") return zh_svchip_auto_detection(inputs)
	if (locale === "tr") return tr_svchip_auto_detection(inputs)
	if (locale === "ru") return ru_svchip_auto_detection(inputs)
	if (locale === "pl") return pl_svchip_auto_detection(inputs)
	return en_svchip_auto_detection(inputs)
});